
import RegionList from './src/RegionList'



let apis = {
   RegionList
};

export default apis;
